import * as React from "react";
const SvgNavChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none", stroke: "currentColor", strokeWidth: 2, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6 9 6 6 6-6" }));
export default SvgNavChevron;
